export default (context) => {
  return {
    config: {
      pageSize: 40,
      resource: "admModule"
    },

    actions: {
      create: {
        reloadGrid: true
      },
      edit: {
        reloadGrid: true
      },
      delete: true,
      print: false,
      export: true,
      search: true
    },

    filter: {
      fields: [],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => false,
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      setValuesBeforePost: (v) => {
        v.accessPrincipal = true
        v.accessDependant = true
        v.accessMaster = true
        return v
      },
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "text",
          label: "ID",
          rules: 'required',
          opts: {
            style: 'float-label'
          },
          renderIf: () => { return context.state.idItemSelected ? false : true }
        },
        {
          col: 12,
          name: "name",
          value: null,
          type: "text",
          label: "Nombre",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "desc",
          value: null,
          type: "text",
          label: "Descripción",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "hidden",
          value: false,
          type: "switch",
          label: "Oculto",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "inactive",
          value: false,
          type: "switch",
          label: "Inactivo",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "sort",
          value: null,
          type: "number",
          label: "Orden",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "content",
          value: null,
          type: "editor",
          label: "Contenido",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "img",
          value: "",
          type: "dropzone",
          label: "Imagen",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: () => "/admModule/file",
            accept: '.jpeg,.jpg,.png'
          }
        },
        {
          col: 6,
          name: "file",
          value: "",
          type: "dropzone",
          label: "Archivo",
          rules: 'ext:pdf',
          opts: {
            path: () => "/admModule/file",
            accept: '.pdf'
          }
        },
        {
          col: 6,
          name: "fileEN",
          value: "",
          type: "dropzone",
          label: "Archivo (EN)",
          rules: 'ext:pdf',
          opts: {
            path: () => "/admModule/fileEN",
            accept: '.pdf'
          }
        }
      ]
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Nombre",
        accessor: "name"
      },
      {
        Header: "Descripción",
        accessor: "desc"
      },
      {
        Header: "Inactivo",
        accessor: "inactive",
        isBool: true
      },
      {
        Header: "Orden",
        accessor: "sort"
      }
    ]
  }
}
